import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesAssignResourceColumnsModel} from "../../models/services-assign-resource-columns.model";

export class ServicesAssignResourceAllocationTableRowCtrl implements IController {
  resourceAllocationData: any;
  extraVolume: any;
  isSelected: boolean;
  hasLogisticsVehiclePermission: boolean;
  columns: ServicesAssignResourceColumnsModel;
  onAttachedVehicleChanged: Function;
  onMainVehicleChanged: Function;

  public attachedVehicleRefCopy: any;
  public mainVehicleRefCopy: any;
  public isVehiclesEditable: any;

  private isDesktop: any;

  /* @ngInject */
  constructor(private $mdMedia) {
  }

  $onInit() {
    this.isDesktop = this.$mdMedia('gt-sm');
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.isSelected && !changes.isSelected.isFirstChange()) {

      if (!_.isUndefined(this.isSelected)) {
        this.isVehiclesEditable = this.isSelected && (!this.resourceAllocationData.route || this.resourceAllocationData.route.status === 'Unassigned');
        this.attachedVehicleRefCopy = this.isVehiclesEditable ? angular.copy(_.get(this.resourceAllocationData.supplyResource, 'attachedLogisticsVehicleReferences[0]')) : undefined;
        this.mainVehicleRefCopy = this.isVehiclesEditable ? angular.copy(_.get(this.resourceAllocationData.supplyResource, 'mainLogisticsVehicleReference')) : undefined;
      } else {
        this.isVehiclesEditable = undefined;
        this.attachedVehicleRefCopy = undefined;
        this.mainVehicleRefCopy = undefined;
      }
    }
  }

  onAttachedVehicleSelected(logisticsVehicle) {
    this.attachedVehicleRefCopy = logisticsVehicle
    this.onAttachedVehicleChanged({logisticsVehicle: this.attachedVehicleRefCopy});
  }

  onMainVehicleSelected(logisticsVehicle) {
    this.mainVehicleRefCopy = logisticsVehicle
    this.onMainVehicleChanged({logisticsVehicle: this.mainVehicleRefCopy});
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignResourceAllocationTableRow', {
    bindings: {
      columns: '<?',
      resourceAllocationData: '<',
      extraVolume: '<?',
      isSelected: '<?',
      hasLogisticsVehiclePermission: '<?',
      onAttachedVehicleChanged: '&?',
      onMainVehicleChanged: '&?',
    },
    template: require('./services-assign-resource-allocation-table-row.html').default,
    controller: ServicesAssignResourceAllocationTableRowCtrl
  });
